import React from "react";
import Popular from "../Components/Popular";
import Veggie from "../Components/Veggie";
const Home = () => {
  return (
    <div>
      <Popular />
      <Veggie />
    </div>
  );
};

export default Home;
